import { render, staticRenderFns } from "./NetworkMarketplaceInvitationBox.vue?vue&type=template&id=9be771f6&scoped=true&"
import script from "./NetworkMarketplaceInvitationBox.vue?vue&type=script&lang=js&"
export * from "./NetworkMarketplaceInvitationBox.vue?vue&type=script&lang=js&"
import style0 from "./NetworkMarketplaceInvitationBox.vue?vue&type=style&index=0&id=9be771f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be771f6",
  null
  
)

export default component.exports